import React from 'react'
import closeImage from '../../images/icons/close_black.svg';


const TopDrawer = ({ open, openClose, image, children }) => {

  return (
    <div className="addPatient">
      <div className={open ? "overlay open" : "overlay"}
        onClick={openClose} ></div>
      <div className={open ? "addItem--wrapper open" : "addItem--wrapper"}>
        <div>{children}</div>
        <a href="#" onClick={openClose}
          className="top-draw-handle  md-button-fab">
          {image || <img alt="Close" className={"open-close " + (open ? "close" : "")}
            src={closeImage} />}
        </a>
      </div>
    </div>
  )
}

export default TopDrawer;



// WEBPACK FOOTER //
// ./src/components/ui/TopDrawer.jsx